import { AccordionPanel } from "features/WorklistTools/shared/components/AccordionPanel";
import { LabwareTypeInfo } from "features/WorklistTools/shared/interfaces";
import "react-tabs/style/react-tabs.css";
import styled from "styled-components";
import { DestinationWellMapping } from "./DestinationWellMapping/DestinationWellMapping";
import { MethodSettings } from "./MethodSettings/MethodSettings";
import { NucToIntMapping } from "./NucToIntMapping/NucToIntMapping";
import { SourceToNucMapping } from "./SourceToNucMapping/SourceToNucMapping";

interface NucleofectionSidebarProps {
  compoundPlateInfo: LabwareTypeInfo[] | undefined;
  destSampleTypes: any;
}

const StyledSidebarContainer = styled.div`
  padding: 20px;
  height: 100%;
  overflow: auto;
  width: 100%;
  resize: horizontal;
`;

export const NucleofectionSidebar = ({
  compoundPlateInfo,
  destSampleTypes,
}: NucleofectionSidebarProps) => {
  return (
    <StyledSidebarContainer>
      <AccordionPanel
        id="method-settings-panel"
        panel="method-settings"
        title="Method Settings"
      >
        <MethodSettings
          compoundPlateTypeInfo={compoundPlateInfo}
          destSampleTypes={destSampleTypes}
        />
      </AccordionPanel>
      <AccordionPanel
        id="source-to-nuc-mapping-panel"
        panel="source-to-nuc-mapping"
        title="Source To Nuc Well Mapping"
      >
        <SourceToNucMapping />
      </AccordionPanel>
      <AccordionPanel
        id="nuc-to-int-mapping-panel"
        panel="nuc-to-int-mapping"
        title="Nuc To Int Well Mapping"
      >
        <NucToIntMapping />
      </AccordionPanel>
      <AccordionPanel
        id="int-to-dest-mapping-panel"
        panel="int-to-dest-mapping"
        title="Int to Dest Well Mapping"
      >
        <DestinationWellMapping />
      </AccordionPanel>
    </StyledSidebarContainer>
  );
};
